/* eslint-disable @nx/enforce-module-boundaries */
import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { MainParticipant } from '@uplift/ui-v2';

const useStyles = makeStyles()(() => ({
  container: {
    height: '100%',
    backgroundColor: 'transparent'
  },
}));

type MainVideoTrackProps = {
  sessionDetails?: string;
  userLableText?: string;
};

export const MainVideoTrack: React.VFC<MainVideoTrackProps> = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <MainParticipant/>
    </Box>
  );
};
